var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "svg-box d-flex"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    className: "circular yellow-stroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: 75,
    cy: 75,
    r: 50,
    fill: "none",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "alert-sign yellow-stroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-615.516,-257.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M634.087,300.805L673.361,261.53",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 621.52,
    cy: 316.126,
    r: 1.318
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.8d3ae73bc44e3a6ef2c173d288496a68.svg";
export { ForwardRef as ReactComponent };